import { useEffect } from "react";
import { useNetwork } from "@mantine/hooks";
import { showNotification, updateNotification } from "@mantine/notifications";
import { IconWifiOff, IconWifi } from "@tabler/icons-react";

export function NetworkStatusNotification() {
  const { online } = useNetwork();

  useEffect(() => {
    if (!online) {
      showNotification({
        id: "network-status",
        title: "You are offline",
        message: "Connection lost. Some features may not work.",
        color: "transparent",
        icon: <IconWifiOff size={18} />,
        autoClose: false,
        withCloseButton: false,
        styles: {
          root: {
            backgroundColor: "var(--mantine-color-red-6)",
          },
          description: {
            color: "white",
          },
          title: {
            color: "white",
            fontWeight: 600,
          },
        },
      });
    } else {
      updateNotification({
        id: "network-status",
        title: "Back online",
        message: "Connection restored.",
        color: "green",
        icon: <IconWifi size={18} />,
        autoClose: 3000,
        withCloseButton: true,
        styles: undefined,
      });
    }
  }, [online]);

  return null;
}
